import * as React from "react";
import { PHASE_KEYS, PHASE_VAR_NAMES, type PhaseKey } from "../constants/phases";

const readVar = (cssVar: string, el: Element | null = null) =>
  getComputedStyle(el ?? document.documentElement).getPropertyValue(cssVar).trim();

/** Reads CSS custom properties (from :root): --stable, --metastable, --transition, --solitons, --unknown */
export function usePhaseColors(): Record<PhaseKey, string> {
  const readAll = () => {
    const out = {} as Record<PhaseKey, string>;
    for (const k of PHASE_KEYS) out[k] = readVar(PHASE_VAR_NAMES[k]);
    return out;
  };

  const [colors, setColors] = React.useState<Record<PhaseKey, string>>(readAll);

  React.useEffect(() => {
    const update = () => setColors(readAll());
    const root = document.documentElement;
    const mo = new MutationObserver(update);
    mo.observe(root, { attributes: true, attributeFilter: ["class", "style"] });
    window.addEventListener("resize", update); // optional: respond to responsive theme swaps
    return () => {
      mo.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return colors;
}
